import { render, staticRenderFns } from "./commoditySales.vue?vue&type=template&id=01dddc64&scoped=true&"
import script from "./commoditySales.vue?vue&type=script&lang=js&"
export * from "./commoditySales.vue?vue&type=script&lang=js&"
import style0 from "./commoditySales.vue?vue&type=style&index=0&id=01dddc64&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dddc64",
  null
  
)

export default component.exports